<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách phiếu nhập kho</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          class="f12 font-medium btn btn-outline-secondary"
          @click="
            $router.push({ path: '/import-warehouse/add' }) &&
              dataPermission.includes('CNPS_DEVICE_ORDER_IMPORT_CREATE')
          "
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button class="f12 font-medium btn btn-outline-secondary" @click="exportExcel()">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transformDateApprove()"
              v-model="dateRangeApprove"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12 pt-1"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian duyệt
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.billNumber"
              class="form-control f12 hc-37 text-search"
              placeholder="Số phiếu nhập"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.inventoryIdImport"
              :options="warehouseData"
              placeholder="Tên kho nhập"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.creatorId"
              :options="dataManager"
              placeholder="Người tạo"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="dataStatus"
              placeholder="Trạng thái"
            ></Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.reasonImport"
              :options="dataReason"
              placeholder="Lý do nhập"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              type="button"
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeForm"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>

            Tổng phiếu nhập: {{ pagination.total }}
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="dataLeads"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(warehouse)="data">
                {{ data.item.inventoryIdImport | transformData(warehouseData) }}
              </template>
              <template #cell(creator)="data">
                <p>
                  {{ data.item.userCreator && data.item.userCreator.name }}
                </p>
                <p>
                  {{ data.item.userCreator && data.item.userCreator.email }}
                </p>
              </template>
              <template #cell(time)="data">
                <p><b>Tạo:</b> {{ data.item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                <p v-if="data.item.timeApprove">
                  <b>Duyệt:</b>
                  {{ data.item.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                </p>
              </template>
              <template #cell(reasonImport)="data">
                {{ data.item.reasonImport | transformData(Config.reasonImportWarehouse) }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status || '']">
                  {{ data.item.status | transformData(dataStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <button class="dropdown-item" @click="detailItem(data.item.id)">
                    <i class="bx bx-detail"></i><span>&nbsp;</span>Chi tiết
                  </button>
                  <button class="dropdown-item" @click="inTicket(data.item.id)">
                    <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canEdit(data.item.status, data.item.userCreator)"
                    @click="editItem(data.item.id)"
                  >
                    <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
                  </button>
                  <button
                    class="dropdown-item"
                    v-if="canApprove(data.item.status, data.item.managerIdInventory)"
                    @click="approveItem(data.item)"
                  >
                    <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
                  </button>
                  <button
                    v-if="canReject(data.item.status, data.item.managerIdInventory)"
                    class="dropdown-item"
                    @click="rejectItem(data.item)"
                  >
                    <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
                  </button>
                  <button
                    v-if="
                      canCancel(
                        data.item.status,
                        data.item.userCreator,
                        data.item.managerIdInventory
                      )
                    "
                    class="dropdown-item"
                    @click="cancelItem(data.item)"
                  >
                    <i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ
                  </button>
                  <button
                    v-if="canCoppy(data.item.status, data.item.userCreator)"
                    class="dropdown-item"
                    @click="copyItem(data.item.id)"
                  >
                    <i class="bx bx-copy"></i><span>&nbsp;</span>Tạo bản copy
                  </button>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>

    <b-modal id="modal-noti" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { StaffService } from '@/services/staff.service'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { DeviceService } from '../../../services/device.service'
  import mxItemAction from './mx-item-action.js'
  import { getLastNDays } from '@/utils/util'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian' },
    { key: 'billNumber', label: 'Số phiếu nhập' },
    { key: 'quantityImport', label: 'Tổng TB nhập', class: 'text-center' },
    { key: 'warehouse', label: 'Tên kho nhập' },
    { key: 'creator', label: 'Người tạo' },
    { key: 'reasonImport', label: 'Lý do nhập' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'reasonReject', label: 'Lý do từ chối', thStyle: 'width: 80px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    mixins: [prepareQueryParamsMixin, mxItemAction],
    data() {
      const { from, to } = getLastNDays(3, 'date')
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        dataLeads: [],
        loading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        localeData: Config.localeData,
        dateRange: {
          startDate: from,
          endDate: to,
        },
        dateRangeApprove: {
          startDate: null,
          endDate: null,
        },
        dataManager: [],
        selected: [],
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        warehouseData: [],
        dataStatus: [{ id: '0', text: 'Tất cả' }, ...Config.statusImportWarehouse],
        dataReason: [{ id: '0', text: 'Tất cả' }, ...Config.reasonImportWarehouse],
        hasDefaultFilter: true,
      }
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    created() {
      this.fetchSuperiors()
      this.fetchWarehouse()
      this.transformDate()
      this.fetchData()
    },
    mounted() {
      this.$root.$on('bv::modal::hide', bvEvent => {
        if (bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
          if (!this.$refs.rejectValue.value.trim()) {
            this.showErr('Lý do nhập không được bỏ trống')
            bvEvent.preventDefault()
          } else if (
            this.$refs.rejectValue.value.trim().length < 2 ||
            this.$refs.rejectValue.value.trim().length > 255
          ) {
            this.showErr('Lý do nhập ký tự nhỏ nhất là 2 và lớn nhất là 255 ký tự')
            bvEvent.preventDefault()
          }
        }
      })
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
      selectAll: {
        get: function () {
          return this.dataLeads ? this.selected.length === this.dataLeads.length : false
        },
        set: function (value) {
          var selected = []
          if (value) {
            this.dataLeads.forEach(function (item) {
              selected.push(item)
            })
          }
          this.selected = selected
        },
      },
    },
    filters: {
      // lấy ngày, giờ
      formatTime(ms) {
        return (
          new Date(ms).getHours() +
          ':' +
          new Date(ms).getMinutes() +
          ', ' +
          new Date(ms).getDate() +
          '/' +
          (new Date(ms).getMonth() + 1) +
          '/' +
          new Date(ms).getFullYear()
        )
      },
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    methods: {
      async fetchSuperiors() {
        try {
          const { data } = await StaffService.superiors()
          const dat = data.map(e => {
            return { id: e.id, text: e.name }
          })
          this.dataManager = [{ id: '0', text: 'Tất cả' }, ...dat]
        } catch (e) {
          console.error(e)
        }
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        const data = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
        this.warehouseData = [{ id: '0', text: 'Tất cả' }, ...data]
      },
      transformDate() {
        this.search.dateFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      transformDateApprove() {
        this.search.timeApproveFrom = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.timeApproveTo = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = { startDate: null, endDate: null }
        this.dateRangeApprove = { startDate: null, endDate: null }
        this.selected = []
        this.hasDefaultFilter = false
        await this.fetchData()
      },

      removeDefaultFilter() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = { startDate: null, endDate: null }
        this.dateRangeApprove = { startDate: null, endDate: null }
        this.selected = []
        this.hasDefaultFilter = false
        this.fetchData()
      },
      async fetchData() {
        try {
          this.tbLoading = true
          if (this.search.inventoryIdImport === '0') {
            delete this.search.inventoryIdImport
          }
          if (this.search.creatorId === '0') delete this.search.creatorId
          if (this.search.status === '0') delete this.search.status

          const response = await DeviceService.getListImportWarehouse(this.search)
          if (response.code === 1000) {
            this.dataLeads = response.data.orders || []
            this.pagination.total = response.data.count ? response.data.count : 0
          } else {
            this.showErr(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async exportExcel() {
        try {
          this.loading = true
          const req = { ...this.search }
          delete req.page
          delete req.limit
          await DeviceService.exportExcelImportWarehouse(req)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
    },
  }
</script>

<style>
  .time-placeholder,
  .text-search::placeholder {
    color: #999 !important;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px !important;
  }
</style>
